import { Directive, HostListener, ElementRef, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appCustomScroll]',
  exportAs: 'appCustomScroll'
})
export class CustomScrollDirective {

  @Output() scrollEvent: EventEmitter<{ top: boolean, bottom: boolean }> = new EventEmitter();

  scrollTop = true;
  scrollBottom = false;
  constructor(private eleRef: ElementRef) { }

  @HostListener('scroll') onScrollEvent(event?: Event) {
    const top: number = this.eleRef.nativeElement.scrollTop;
    const offSetHeight: number = this.eleRef.nativeElement.offsetHeight;
    const scrollHeight: number = this.eleRef.nativeElement.scrollHeight;
    if (top === 0) {
      this.scrollTop = true;
    } else {
      this.scrollTop = false;
    }
    if (top > scrollHeight - offSetHeight - 1) {
      this.scrollBottom = true;
    } else {
      this.scrollBottom = false;
    }

    this.scrollEvent.emit({ top: this.scrollTop, bottom: this.scrollBottom });
  }
}